module.exports = __webpack_public_path__ + "static/media/asterik.59105b43.svg";